import { Box, Popover, PopoverBody, PopoverContent, PopoverTrigger } from '@chakra-ui/react';
import { ReactNode, useEffect, useRef } from 'react';

import {
  CustomerNotification,
  DismissCustomerNotificationMutationFn,
} from '../../../gql/generated/graphql';
import NotificationsHeader from './NofificationsHeader';
import NotificationItem from './NotificationItem';
import NotificationsZeroState from './NotificationsZeroState';

type DesktopNotificationsProps = {
  children: ReactNode;
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  notDismissedNotifications: CustomerNotification[];
  dismissedNotifications: CustomerNotification[];
  dismissNotification: DismissCustomerNotificationMutationFn;
  showDismissed: boolean;
  toggleShowDismissed: () => void;
  setOpenNotificationModal: (a: string | null) => void;
};

const DesktopNotifications = ({
  children,
  isOpen,
  onOpen,
  onClose,
  notDismissedNotifications = [],
  dismissedNotifications = [],
  dismissNotification,
  showDismissed,
  toggleShowDismissed,
  setOpenNotificationModal,
}: DesktopNotificationsProps) => {
  const notifications = showDismissed ? dismissedNotifications : notDismissedNotifications;
  const hasNotifications = notifications.length > 0;

  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (ref.current) {
      // Hack to hide the popover when showing dismissed and click outside
      ref.current.focus();
    }
  }, [showDismissed]);

  return (
    <Popover
      returnFocusOnClose={false}
      isOpen={isOpen}
      onClose={onClose}
      onOpen={onOpen}
      closeOnBlur
      placement="bottom-end"
    >
      <PopoverTrigger>{children}</PopoverTrigger>
      <PopoverContent ref={ref} w="400px" maxH="400px" overflowY="auto">
        <PopoverBody>
          <NotificationsHeader
            m={4}
            showDismissed={showDismissed}
            toggleShowDismissed={toggleShowDismissed}
          />
          <Box m={3}>
            {hasNotifications ? (
              notifications.map((notification) => (
                <NotificationItem
                  key={`desktop-notification-${notification.id}`}
                  showDismissed={showDismissed}
                  notification={notification}
                  dismissNotification={dismissNotification}
                  setOpenNotificationModal={setOpenNotificationModal}
                />
              ))
            ) : (
              <NotificationsZeroState showDismissed={showDismissed} />
            )}
          </Box>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default DesktopNotifications;
